function pauseAllMedia() {
  document.querySelectorAll('[data-host="youtube"]').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('[data-host="vimeo"]').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

window.theme.pauseAllMedia = pauseAllMedia;

window.theme.scrollTo = (elementTop) => {
  const stickyHeaderHeight = document.querySelector('[data-header-sticky]') ? document.querySelector('[data-header-height]').offsetHeight : 0;

  window.scrollTo({
    top: elementTop + window.scrollY - stickyHeaderHeight,
    left: 0,
    behavior: 'smooth',
  });
};
